var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hp-reports" },
    [
      _c(
        "z-caption",
        {
          staticClass: "u-bottom-margin--xl",
          attrs: {
            size: "xl",
            href: "/" + _vm.$root.lang + "/investors/reports-and-results/",
            uppercase: "",
          },
        },
        [_c("span", { domProps: { innerHTML: _vm._s(_vm.text.title) } })]
      ),
      _vm._v(" "),
      _c(
        "slider",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.device !== "mobile",
              expression: "device !== 'mobile'",
            },
          ],
          attrs: { "space-between": 32 },
        },
        _vm._l(_vm.desktopSlides, function (slide, slideIndex) {
          return _c("slide", { key: slideIndex }, [
            _c("div", { staticClass: "hp-reports-slide" }, [
              _c(
                "div",
                { staticClass: "row hp-reports-slide__row" },
                _vm._l(slide, function (card, cardIndex) {
                  return _c(
                    "div",
                    {
                      key: cardIndex,
                      staticClass: "col-default-6 col-mobile-12",
                    },
                    [
                      _c("z-report-block", {
                        class: [
                          "hp-reports-slide__card",
                          { "hp-reports-slide__card--mt": cardIndex % 2 !== 0 },
                        ],
                        attrs: {
                          image: card.image,
                          link: card.link,
                          title: card.title,
                          interactive: "hover",
                          "title-period": card.titlePeriod,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "slider",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.device === "mobile",
              expression: "device === 'mobile'",
            },
          ],
          attrs: { "space-between": 32 },
        },
        _vm._l(_vm.data, function (item, index) {
          return _c("slide", { key: index }, [
            _c("div", { staticClass: "hp-reports-slide" }, [
              _c("div", { staticClass: "row hp-reports-slide__row" }, [
                _c(
                  "div",
                  { staticClass: "col-default-6 col-mobile-12" },
                  [
                    _c("z-report-block", {
                      staticClass: "hp-reports-slide__card",
                      attrs: {
                        image: item.image,
                        link: item.link,
                        title: item.title,
                        "title-period": item.titlePeriod,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }